import {
  BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44,
  BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54,
  BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64,
  BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER,
  BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35,
} from './constants';
import { TargetScoreRangeAgeGroup } from '../../../TargetScore';

export function getBtBreakpointsFromAgeGroup(ageGroup: TargetScoreRangeAgeGroup) {
  switch (ageGroup) {
    case 'Under35':
      return BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35;
    case '35To44':
      return BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44;
    case '45To54':
      return BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54;
    case '55To64':
      return BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64;
    case '65AndOver':
      return BUSINESS_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER;
    default:
      return [];
  }
}
